import { render } from "./SysParamDialog.vue?vue&type=template&id=1837142a&scoped=true"
import script from "./SysParamDialog.vue?vue&type=script&lang=js"
export * from "./SysParamDialog.vue?vue&type=script&lang=js"

import "./SysParamDialog.vue?vue&type=style&index=0&id=1837142a&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1837142a"]])

export default __exports__